import React from 'react'
import PropTypes from 'prop-types'
import {withStyles} from 'material-ui/styles'
import MUITabs from 'material-ui/Tabs'

const styles = theme => ({
  Tabs: {
    borderRadius: 24,
    boxSizing: 'border-box',
    // padding: 0,
    boxShadow: '0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24)',
    background: '#fff',
  },
  TabIndicator: {
    height: 4,
  },
})

const Tabs = ({classes, children, value, onChange}) => {

  let nodes = []
  if (Array.isArray(children)) {
    nodes = children
  } else {
    nodes = [children]
  }

  return (
    <MUITabs
      value={value}
      onChange={onChange}
      centered={true}
      fullWidth={false}
      indicatorColor="secondary"
      className={classes.Tabs}
      // classes={{indicator: classes.TabIndicator}} // TODO revisit
    >
      {nodes // TODO react.children.map
        // .filter(c => c.type.displayName === 'WithStyles(Tab)') // TODO revisit
        .map((c, i) => React.cloneElement(c, {key: i}))
      }
    </MUITabs>
  )
}

Tabs.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  value: PropTypes.any.isRequired,
  onChange: PropTypes.func,
}

export default withStyles(styles, {withTheme: true})(Tabs)



// WEBPACK FOOTER //
// ./src/components/tabs.jsx